import React from 'react';

import { Col, Row, Text } from '@opendoor/bricks-next';
import type { TextProps } from '@opendoor/bricks-next';

export interface NavigationBarProps {
  id?: string;
  title?: string;
  titleProps?: Partial<TextProps>;
  subtitle?: string;
  rightComponent?: React.ReactNode;
  subtitleProps?: Partial<TextProps>;
  leftComponent?: React.ReactNode;
}

const getNavigationBarTitleId = (props: Pick<NavigationBarProps, 'id'>) => {
  return `${props.id || 'navigation-bar'}-title`;
};

export const NavigationBar: React.FC<NavigationBarProps> = ({
  id,
  title,
  titleProps,
  subtitle,
  rightComponent,
  subtitleProps,
  leftComponent,
}) => {
  const hasTitle = !!title;
  return (
    <Row
      backgroundColor="$backgroundPrimary"
      py="$3half"
      pl="$6"
      $largerThanSM={{ pl: '$8' }}
      $largerThanMD={{ pl: '$10' }}
      pr="$5"
      flex={1}
      flexShrink={1}
      flexBasis="auto"
      alignItems="center"
      justifyContent="flex-start"
      id={id}
      zIndex={2000}
    >
      {leftComponent && (
        <Row
          flexBasis={hasTitle ? '50%' : 'auto'}
          justifyContent="flex-start"
          alignItems="center"
          flexShrink={2}
        >
          {leftComponent}
        </Row>
      )}
      {title && (
        <Col flexBasis="100%" flexShrink={1}>
          <Text
            typography="$labelMedium"
            fontWeight="$medium"
            whiteSpace="nowrap"
            tag="h1"
            id={getNavigationBarTitleId({ id })}
            textOverflow="ellipsis"
            overflow="hidden"
            {...titleProps}
          >
            {title}
          </Text>
          {subtitle && (
            <Text
              typography="$bodyLarge"
              fontWeight="$regular"
              whiteSpace="nowrap"
              tag="h2"
              textOverflow="ellipsis"
              overflow="hidden"
              {...subtitleProps}
            >
              {subtitle}
            </Text>
          )}
        </Col>
      )}

      <Row
        flexBasis={hasTitle ? '50%' : 'auto'}
        justifyContent="flex-end"
        alignItems="center"
        flexShrink={2}
      >
        {rightComponent}
      </Row>
    </Row>
  );
};
